<template>
  <v-container class="khmer" fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout row>
        <BarChart :chart-data="datacollection"></BarChart>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>
<script>
import BarChart from './BarChart';

export default {
  components: {
    BarChart,
  },
  data() {
    return {
      datacollection: null,
    };
  },
  mounted() {
    this.fillData();
  },
  methods: {
    fillData() {
      this.datacollection = {
        labels: ['A', 'B'],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [this.getRandomInt(), this.getRandomInt()],
          },
        ],
      };
    },
    getRandomInt() {
      return Math.floor(Math.random() * ((50 - 5) + 1)) + 5;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/EventScanner.vue